var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pessoa
    ? _c(
        "div",
        [
          _c(
            "el-row",
            { staticClass: "pad5" },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("CPF:")]),
                  _c("span", [
                    _vm._v("  " + _vm._s(_vm.filterNull(_vm.pessoa.cpf)))
                  ])
                ])
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("Nome:")]),
                  _c("span", [
                    _vm._v("  " + _vm._s(_vm.filterNull(_vm.pessoa.nome)))
                  ])
                ])
              ]),
              _vm.isProcessoFisicoConjuge
                ? _c("el-col", { attrs: { span: 12 } }, [
                    _c("p", [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("Tipo de documento:")
                      ]),
                      _c("span", [
                        _vm._v(
                          "  " +
                            _vm._s(_vm.filterNull(_vm.pessoa.tipoDocumento))
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.pessoa.tipoDocumento == "OUTROS" &&
              _vm.isProcessoFisicoConjuge
                ? _c("el-col", { attrs: { span: 12 } }, [
                    _c("p", [
                      _c("span", { staticClass: "label" }, [_vm._v("Outros:")]),
                      _c("span", [
                        _vm._v(
                          "  " +
                            _vm._s(
                              _vm.filterNull(_vm.pessoa.outrosTipoDocumento)
                            )
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("RG:")]),
                  _c("span", [
                    _vm._v("  " + _vm._s(_vm.filterNull(_vm.pessoa.rg)))
                  ])
                ])
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("Órgão expedidor:")
                  ]),
                  _c("span", [
                    _vm._v(
                      "  " +
                        _vm._s(_vm.filterNull(_vm.pessoa.orgaoExpedidor.nome))
                    )
                  ])
                ])
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("p", [
                  _c("span", { staticClass: "label" }, [_vm._v("UF do RG:")]),
                  _c("span", [
                    _vm._v("  " + _vm._s(_vm.getUfRg(_vm.pessoa) || "-"))
                  ])
                ])
              ]),
              !_vm.isProcessoFisicoConjuge
                ? _c("el-col", { attrs: { span: 12 } }, [
                    _c("p", [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("Nacionalidade:")
                      ]),
                      _c("span", [_vm._v("  " + _vm._s(_vm.nomeGentilico))])
                    ])
                  ])
                : _vm._e(),
              !_vm.isProcessoFisicoConjuge
                ? _c("el-col", { attrs: { span: 12 } }, [
                    _c("p", [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("Data de nascimento:")
                      ]),
                      _c("span", [
                        _vm._v(
                          "  " +
                            _vm._s(
                              _vm.filterNullDate(_vm.pessoa.dataNascimento)
                            )
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.isBrasileiro
                ? _c("el-col", { attrs: { span: 12 } }, [
                    _c("p", [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("UF da naturalidade:")
                      ]),
                      _c("span", [
                        _vm._v(
                          "  " +
                            _vm._s(_vm.filterNull(_vm.pessoa.ufNaturalidade))
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.isBrasileiro
                ? _c("el-col", { attrs: { span: 12 } }, [
                    _c("p", [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("Município da naturalidade:")
                      ]),
                      _c("span", [
                        _vm._v(
                          "  " +
                            _vm._s(
                              _vm.pessoa.naturalidade
                                ? _vm.filterNull(_vm.pessoa.naturalidade.nome)
                                : "-"
                            )
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._t("default")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4065e424", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4065e424","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resumo/AppResumoPessoaFisica.vue
// module id = null
// module chunks = 